import React, { useState, useEffect } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

const CountdownTimer = ({ burnAfterReading, secId }) => {
  // Convert burnAfterReading from minutes to seconds
  const totalSeconds = burnAfterReading;

  const [timeLeft, setTimeLeft] = useState(totalSeconds);

  

  useEffect(() => {
    if (burnAfterReading !== null) {

    
      const interval = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(interval);
            deleteSecretAfterBurn(secId); // Call the function to delete the secret
            
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);

      return () => clearInterval(interval); // Cleanup the interval on unmount
    }
  }, [burnAfterReading]);

  const deleteSecretAfterBurn = async (secId) => {
    const functions = getFunctions();
    const deleteSecret = httpsCallable(functions, 'deleteSecret');
    await deleteSecret({ secretId: secId });
    // reload the page 
    window.location.reload();
 }
  // Format time as mm:ss
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;

  return (
    <div>
      {burnAfterReading !== null && timeLeft > 0 ? (
        <p>Time left to view the secret: {formattedTime}</p>
      ) : (
        <p>The secret has expired or is no longer available.</p>
      )}
    </div>
  );
};

export default CountdownTimer;
